{
  "v3.ta.agent.acces": "Agent access with the owner",
  "v3.ta.agent.aucun_modele": "none",
  "v3.ta.agent.aucun_modele_autorise": "No AI model allowed in this project.",
  "v3.ta.agent.configuration": "Configuration",
  "v3.ta.agent.consigne": "Instructions: {{consigne}}",
  "v3.ta.agent.consigne_champ": "Instructions",
  "v3.ta.agent.cree": "Agent created.",
  "v3.ta.agent.creer": "Create the agent",
  "v3.ta.agent.echec_creer": "The agent was not created.",
  "v3.ta.agent.echec_enregistrer": "The agent was not saved.",
  "v3.ta.agent.en_revue_non_modifiable": "The agent is under review: it cannot be edited.",
  "v3.ta.agent.enregistre": "Agent saved.",
  "v3.ta.agent.enregistrer": "Save",
  "v3.ta.agent.etat.draft": "Draft",
  "v3.ta.agent.etat.in_review": "Under review",
  "v3.ta.agent.etat.promoted": "Promoted to the organisation",
  "v3.ta.agent.etat.refused": "Refused",
  "v3.ta.agent.etat_motif": "{{etat}} — reason: {{motif}}",
  "v3.ta.agent.fiche_etat.brouillon": "Draft",
  "v3.ta.agent.fiche_etat.en_revue": "Under review",
  "v3.ta.agent.fiche_etat.promu": "Promoted to the organisation",
  "v3.ta.agent.fiche_etat.refuse": "Refused",
  "v3.ta.agent.libelle": "agent",
  "v3.ta.agent.modele": "model {{modele}}",
  "v3.ta.agent.modele_champ": "AI model",
  "v3.ta.agent.modele_nom": "Model: {{modele}}",
  "v3.ta.agent.modifier": "Edit the draft",
  "v3.ta.agent.nom": "Name",
  "v3.ta.agent.nom_requis": "The name is required.",
  "v3.ta.agent.outils": "Tools: {{outils}}",
  "v3.ta.agent.preparation": "run readiness",
  "v3.ta.agent.pret": "The agent can run.",
  "v3.ta.agent.role": "Role: {{role}}",
  "v3.ta.agent.role_champ": "Role",
  "v3.ta.agent.role_exemples": "For example: product owner, developer, tester.",
  "v3.ta.agent.role_libre": "Free role",
  "v3.ta.agent.role_libre_option": "Organisation free role",
  "v3.ta.agent.role_requis": "The role is required.",
  "v3.ta.agent.titre": "Project custom agent",
  "v3.ta.agent.titre_creer": "Create a project custom agent",
  "v3.ta.agent.titre_modifier": "Edit an agent draft",
  "v3.ta.agent.tous": "All agents",
  "v3.ta.agents.agent_a_executer": "Agent to run",
  "v3.ta.agents.associations": "server associations",
  "v3.ta.agents.aucune_association": "No approved, active association.",
  "v3.ta.agents.aucune_choisie": "Choose a purpose to see its decision and your consent.",
  "v3.ta.agents.choisir_agent": "Choose an agent…",
  "v3.ta.agents.consentement_echec": "The consent was not recorded.",
  "v3.ta.agents.consentement_enregistre": "Consent recorded.",
  "v3.ta.agents.consentement_requis": "Each person gives consent before running the agent.",
  "v3.ta.agents.consenti": "Consent given until {{date}}.",
  "v3.ta.agents.creer": "Create an agent",
  "v3.ta.agents.declarer_finalite": "Declare a purpose",
  "v3.ta.agents.demander_promotion": "Request promotion",
  "v3.ta.agents.donner_consentement": "Give my consent",
  "v3.ta.agents.en_cours": "The agent is working…",
  "v3.ta.agents.executer": "Run",
  "v3.ta.agents.executer_serveur": "Run through the tool server",
  "v3.ta.agents.executer_titre": "Run an agent",
  "v3.ta.agents.execution_echec": "The run did not succeed.",
  "v3.ta.agents.executions": "Runs",
  "v3.ta.agents.executions_vide": "No run.",
  "v3.ta.agents.finalites": "Project purposes",
  "v3.ta.agents.finalites_vide": "No purpose declared.",
  "v3.ta.agents.instruction": "Instruction",
  "v3.ta.agents.instruction_requise": "Enter an instruction.",
  "v3.ta.agents.jusqu_au": "until {{date}}",
  "v3.ta.agents.lire_associations": "Read the associations",
  "v3.ta.agents.liste": "Project agents",
  "v3.ta.agents.liste_libelle": "project agents",
  "v3.ta.agents.motif": "reason: {{motif}}",
  "v3.ta.agents.non_consenti": "Consent not given.",
  "v3.ta.agents.promotion_echec": "The promotion did not succeed.",
  "v3.ta.agents.promotion_faite": "Promotion updated.",
  "v3.ta.agents.relance": "Agent retried.",
  "v3.ta.agents.relance_echec": "The retry did not succeed.",
  "v3.ta.agents.relancer": "Retry",
  "v3.ta.agents.relancer_nom": "Retry {{nom}}",
  "v3.ta.agents.relecteur": "Reviewer (identifier)",
  "v3.ta.agents.relecteur_aide": "A person from the organisation, other than the author.",
  "v3.ta.agents.relecteur_requis": "Name a reviewer from the organisation.",
  "v3.ta.agents.resultat_vide": "No result yet.",
  "v3.ta.agents.retirer_consentement": "Withdraw my consent",
  "v3.ta.agents.retirer_promotion": "Withdraw promotion",
  "v3.ta.agents.roles_du_modele": "Model agent roles: {{roles}}",
  "v3.ta.agents.sans_sortie": "Run finished without output text.",
  "v3.ta.agents.serveur": "Tool server (identifier)",
  "v3.ta.agents.serveur_lance": "Run started ({{job}}), written to the log.",
  "v3.ta.agents.serveur_requis": "Enter the tool server identifier.",
  "v3.ta.agents.serveur_titre": "Run through a tool server",
  "v3.ta.agents.titre": "Project custom agents and purposes",
  "v3.ta.agents.usage": "Run {{id}} · {{jetons}} tokens",
  "v3.ta.agents.valable": "Valid for {{jours}} days.",
  "v3.ta.agents.vide": "No custom agent in this project.",
  "v3.ta.annuler": "Cancel",
  "v3.ta.arrivee.v3_p07": "package v3-p07 (project settings)",
  "v3.ta.arrivee.v5": "wave V5",
  "v3.ta.categories.completer": "Complete with a change",
  "v3.ta.categories.deroger": "Request a waiver",
  "v3.ta.categories.ecart": "Deviation from the imposed value: {{liste}}",
  "v3.ta.categories.imposee": "Imposed: {{valeur}}",
  "v3.ta.categories.liste": "choices by category",
  "v3.ta.categories.modifier": "Change the choice",
  "v3.ta.categories.obligatoire_vide": "Mandatory category is empty.",
  "v3.ta.categories.regle_propagation": "Only inherited categories follow propagations; an own choice only changes through a change request.",
  "v3.ta.categories.titre": "Project technologies — by category",
  "v3.ta.categories.vide": "No technology category.",
  "v3.ta.changement.libelle": "technology change",
  "v3.ta.changements.auteur": "by {{auteur}}",
  "v3.ta.changements.filtre_etat": "Status",
  "v3.ta.changements.filtre_origine": "Origin",
  "v3.ta.changements.liste": "technology changes",
  "v3.ta.changements.nouveau": "New change",
  "v3.ta.changements.origine.du_projet": "From the project",
  "v3.ta.changements.origine.propagee": "Propagated by the programme or organisation",
  "v3.ta.changements.origine.toutes": "All origins",
  "v3.ta.changements.reprise": "Items reworked: {{fait}} / {{total}}",
  "v3.ta.changements.titre": "Project technology changes",
  "v3.ta.changements.toutes": "All statuses",
  "v3.ta.changements.vide": "No technology change.",
  "v3.ta.code.AGENT_IN_REVIEW": "The agent is under review: it cannot be edited.",
  "v3.ta.code.AGENT_MODEL_MISSING": "The agent’s model is not granted to the organisation.",
  "v3.ta.code.AGENT_PROMOTED_LOCKED": "The agent is promoted to the organisation: it can no longer be edited here.",
  "v3.ta.code.AGENT_PROMOTION_STATE": "Promotion is not allowed in the agent’s current state.",
  "v3.ta.code.AGENT_REVIEWER_REQUIRED": "Name a reviewer from the organisation.",
  "v3.ta.code.AGENT_REVIEWER_UNKNOWN": "Reviewer unknown in the organisation.",
  "v3.ta.code.AI_CONSENT_MISSING": "Your consent is missing for this agent’s purpose.",
  "v3.ta.code.AI_KILL_SWITCH_ACTIVE": "AI is stopped by the organisation or the platform.",
  "v3.ta.code.AI_MODEL_UNAVAILABLE": "The AI model is unavailable.",
  "v3.ta.code.AI_PURPOSE_MISSING": "No approved purpose for this agent.",
  "v3.ta.code.AI_PURPOSE_OR_CONSENT_DENIED": "Purpose or consent missing to run this agent.",
  "v3.ta.code.AI_PURPOSE_PENDING": "This agent’s purpose awaits the organisation’s decision.",
  "v3.ta.code.AI_PURPOSE_PENDING_EXISTS": "A purpose with this code is already awaiting a decision.",
  "v3.ta.code.COMPOSITION_HORS_MODELE": "The project model does not allow this composition.",
  "v3.ta.code.CONFLIT_DE_VERSION": "The agent was changed in the meantime: reload its page.",
  "v3.ta.code.DROIT_NON_TENU": "You do not hold the right this action requires.",
  "v3.ta.code.IDEMPOTENCE_CONFLIT": "A different request was already sent with this key: reopen the dialog.",
  "v3.ta.code.QUOTA_EXCEEDED": "Retry limit reached.",
  "v3.ta.code.SELF_REVIEW_REFUSED": "The reviewer must be someone other than the author.",
  "v3.ta.code.TECHNOLOGIE_NON_PROPOSABLE": "A chosen technology cannot be proposed: choose a qualified, allowed technology.",
  "v3.ta.code.TECH_CHANGE_ADR_REQUIRED": "A major change requires a linked architecture decision.",
  "v3.ta.code.TECH_CHANGE_ALREADY_VOTED": "You have already decided this change.",
  "v3.ta.code.TECH_CHANGE_CONFIRMATION_MISSING": "A named confirmation is missing before submission.",
  "v3.ta.code.TECH_CHANGE_IMMUTABLE": "This change can no longer be edited.",
  "v3.ta.code.TECH_CHANGE_IN_PROGRESS": "Another change for this category is in progress.",
  "v3.ta.code.TECH_CHANGE_NOT_DECIDED": "The change has not been decided yet.",
  "v3.ta.code.TECH_CHANGE_REWORK_OPEN": "Rework is not finished: the change cannot be closed.",
  "v3.ta.code.TECH_CHANGE_SELF_APPROVAL": "The author of a request cannot decide it.",
  "v3.ta.code.TECH_CHANGE_TRANSITION": "This action is not allowed in the change’s current state.",
  "v3.ta.code.TECH_ENTRY_NOT_IMPOSED": "This technology is not imposed: no waiver is needed.",
  "v3.ta.code.TECH_NOT_GENERABLE_UNCONFIRMED": "Combination cannot be generated: accept manual delivery before submitting.",
  "v3.ta.code.VALIDATION_ERROR": "The gateway refused the input: check the fields.",
  "v3.ta.code.WAIVER_ALREADY_ACTIVE": "A waiver is already active for this technology.",
  "v3.ta.code.WAIVER_EXPIRY_REQUIRED": "The waiver expiry date is required.",
  "v3.ta.decider.accepter": "Accept",
  "v3.ta.decider.auteur": "You are the author of this request: someone else decides.",
  "v3.ta.decider.decide": "Decision recorded, written to the log.",
  "v3.ta.decider.decision": "Decision",
  "v3.ta.decider.echec": "The decision was not recorded.",
  "v3.ta.decider.motif_court": "The reason has at least {{min}} characters.",
  "v3.ta.decider.refuser": "Refuse",
  "v3.ta.decider.titre": "Decide a technology change",
  "v3.ta.derogation.aucune_imposee": "No technology is imposed on the project: no waiver to request.",
  "v3.ta.derogation.categorie_technologie": "Category and technology",
  "v3.ta.derogation.conservee": "Current technology kept: {{valeur}}",
  "v3.ta.derogation.demandee": "Waiver requested, written to the log.",
  "v3.ta.derogation.demander": "Request the waiver",
  "v3.ta.derogation.echeance": "Expiry",
  "v3.ta.derogation.echeance_future": "The expiry is required and must be in the future.",
  "v3.ta.derogation.echec": "The waiver was not requested.",
  "v3.ta.derogation.justification": "Justification",
  "v3.ta.derogation.justification_requise": "The justification is required.",
  "v3.ta.derogation.sans_entree": "No current technology to keep: the waiver does not apply.",
  "v3.ta.derogation.suite_attente": "The propagation waits for the decision for this project.",
  "v3.ta.derogation.suite_organisation": "The waiver is decided by the organisation.",
  "v3.ta.derogation.suite_propagation": "Before a propagation, the propagation waits for the decision for this project.",
  "v3.ta.derogation.suite_refusee": "If refused or expired, the change applies.",
  "v3.ta.derogation.titre_ecart": "Request a waiver to keep the deviation",
  "v3.ta.derogation.titre_technologique": "Request a technology waiver",
  "v3.ta.derogation.vise": "{{ref}} — {{categorie}}",
  "v3.ta.dimension.code": "Code",
  "v3.ta.dimension.design": "Design",
  "v3.ta.dimension.environments": "Environments",
  "v3.ta.dimension.versions": "Versions",
  "v3.ta.ecran_non_realise": "“{{ecran}}” is not built yet: it comes with {{arrivee}}.",
  "v3.ta.etat.chargement": "Loading: {{quoi}}…",
  "v3.ta.etat.en_cours": "In progress…",
  "v3.ta.etat.erreur": "Could not read: {{quoi}}.",
  "v3.ta.etat.introuvable": "Not found: {{quoi}}.",
  "v3.ta.etat.reessayer": "Retry",
  "v3.ta.etat.refus": "Access denied: {{quoi}}.",
  "v3.ta.execution.error": "In error",
  "v3.ta.execution.idle": "Idle",
  "v3.ta.execution.running": "Running",
  "v3.ta.fiche.adr": "Linked architecture decision (number)",
  "v3.ta.fiche.adr_requise": "A major change requires a linked architecture decision.",
  "v3.ta.fiche.ajouter_reprise": "Add an item to rework",
  "v3.ta.fiche.analyser": "Analyse",
  "v3.ta.fiche.annuler_changement": "Cancel the change",
  "v3.ta.fiche.annuler_titre": "Cancel change {{ref}}?",
  "v3.ta.fiche.clore": "Close",
  "v3.ta.fiche.comptes": "Items to rework: {{elements}} · tests: {{tests}} · requirements: {{exigences}}",
  "v3.ta.fiche.confirmations": "Named confirmations",
  "v3.ta.fiche.confirmee": "{{dimension}} confirmed by {{par}} on {{le}}",
  "v3.ta.fiche.confirmer_a_mon_nom": "Confirm in my name",
  "v3.ta.fiche.decider": "Decide",
  "v3.ta.fiche.declaration": "Statement",
  "v3.ta.fiche.declaration_requise": "Enter your statement.",
  "v3.ta.fiche.derogation_ecart": "Request the waiver to keep the deviation",
  "v3.ta.fiche.dimension": "Dimension to confirm",
  "v3.ta.fiche.echec": "The action did not succeed.",
  "v3.ta.fiche.enregistrer": "Save the draft",
  "v3.ta.fiche.fait": "Done.",
  "v3.ta.fiche.garder_ecart": "Keep the deviation",
  "v3.ta.fiche.garder_ecart_titre": "Keep the deviation from {{ref}}?",
  "v3.ta.fiche.impact": "Impact analysis",
  "v3.ta.fiche.livraison_manuelle": "I accept manual delivery (combination cannot be generated).",
  "v3.ta.fiche.motif": "Reason",
  "v3.ta.fiche.motif_aide": "Changing the reason or value cancels the analysis.",
  "v3.ta.fiche.motif_decision": "Decision reason: {{motif}}",
  "v3.ta.fiche.non_analysee": "Impact analysis not done.",
  "v3.ta.fiche.non_regression": "Non-regression statement",
  "v3.ta.fiche.non_regression_requise": "The non-regression statement is required to close.",
  "v3.ta.fiche.reprise": "Items to rework",
  "v3.ta.fiche.reprise_vide": "No item to rework.",
  "v3.ta.fiche.risque": "Regression risk: {{risque}}",
  "v3.ta.fiche.soumettre": "Submit",
  "v3.ta.fiche.titre": "Technology change",
  "v3.ta.fiche.tous": "All changes",
  "v3.ta.fiche.trace": "The action and its reason are written to the log.",
  "v3.ta.fiche.verifier_reprise": "Verify the rework",
  "v3.ta.finalite.approved": "Approved",
  "v3.ta.finalite.proposed": "Declared",
  "v3.ta.finalite.refused": "Refused",
  "v3.ta.finalite.superseded": "Superseded",
  "v3.ta.finalite.withdrawn": "Withdrawn",
  "v3.ta.finalite_dialogue.agent": "Agent",
  "v3.ta.finalite_dialogue.code": "Purpose code",
  "v3.ta.finalite_dialogue.code_requis": "The purpose code is required.",
  "v3.ta.finalite_dialogue.declaree": "Purpose declared, written to the log.",
  "v3.ta.finalite_dialogue.declarer": "Declare",
  "v3.ta.finalite_dialogue.duree": "Validity (days)",
  "v3.ta.finalite_dialogue.duree_max": "{{max}} days at most.",
  "v3.ta.finalite_dialogue.echec": "The purpose was not declared.",
  "v3.ta.finalite_dialogue.suite_consentement": "Once approved, each person gives consent.",
  "v3.ta.finalite_dialogue.suite_organisation": "The purpose is decided by the organisation.",
  "v3.ta.finalite_dialogue.titre": "Declare an agent’s AI processing purpose",
  "v3.ta.historique.aucun_ecart": "No difference between the two versions.",
  "v3.ta.historique.aucune": "No version selected.",
  "v3.ta.historique.auteur": "Author: {{auteur}}",
  "v3.ta.historique.comparer": "Compare",
  "v3.ta.historique.comparer_avec": "Compare with",
  "v3.ta.historique.ecarts": "differences between versions",
  "v3.ta.historique.introuvable": "Version {{n}} not found: the current version is displayed.",
  "v3.ta.historique.ligne": "Version {{n}} — {{origine}}",
  "v3.ta.historique.liste": "technology versions",
  "v3.ta.historique.nombre_choix": "{{n}} technology choices.",
  "v3.ta.historique.titre": "Project technologies — history",
  "v3.ta.historique.version_affichee": "Displayed version",
  "v3.ta.historique.version_n": "Version {{n}}",
  "v3.ta.historique.vide": "No version: the launch is not complete.",
  "v3.ta.lancement.ajouter_composant": "Add a component",
  "v3.ta.lancement.categories_vides": "Choose a technology for: {{liste}}.",
  "v3.ta.lancement.choisir": "Choose…",
  "v3.ta.lancement.choix_propre": "Own choice",
  "v3.ta.lancement.composition_vide": "Add at least one component.",
  "v3.ta.lancement.deja_termine": "The launch is already complete.",
  "v3.ta.lancement.echec_enregistrer": "The draft was not saved.",
  "v3.ta.lancement.echec_terminer": "The launch was not completed.",
  "v3.ta.lancement.enregistre": "Draft saved.",
  "v3.ta.lancement.enregistrer": "Save the draft",
  "v3.ta.lancement.etape.1": "technical composition",
  "v3.ta.lancement.etape.2": "technologies by category",
  "v3.ta.lancement.etape.3": "summary",
  "v3.ta.lancement.etape_k": "Step {{k}} of 3: {{titre}}",
  "v3.ta.lancement.heritage": "Inheritance — {{categorie}}",
  "v3.ta.lancement.herite": "Inherit",
  "v3.ta.lancement.herite_vide": "Nothing to inherit.",
  "v3.ta.lancement.modifier_composant": "Edit",
  "v3.ta.lancement.modifier_composant_nom": "Edit {{element}}",
  "v3.ta.lancement.obligatoire": "(mandatory)",
  "v3.ta.lancement.pile_composant": "Component stack",
  "v3.ta.lancement.pile_ou_composition": "Ready stack or composition",
  "v3.ta.lancement.pile_prete": "Qualified ready stack",
  "v3.ta.lancement.pile_requise": "Enter the component stack.",
  "v3.ta.lancement.plateforme": "Target platform",
  "v3.ta.lancement.plateforme_aucune": "No qualified system",
  "v3.ta.lancement.plus_tard": "Later",
  "v3.ta.lancement.precedente": "Previous step",
  "v3.ta.lancement.retirer_composant": "Remove",
  "v3.ta.lancement.retirer_composant_nom": "Remove {{element}}",
  "v3.ta.lancement.retirer_confirmer": "Remove component {{element}}?",
  "v3.ta.lancement.retirer_consequence": "Its links are removed with it.",
  "v3.ta.lancement.role_composant": "Component role",
  "v3.ta.lancement.suivante": "Next step",
  "v3.ta.lancement.sur_mesure": "Custom composition",
  "v3.ta.lancement.technologie": "Technology — {{categorie}}",
  "v3.ta.lancement.termine": "Launch complete.",
  "v3.ta.lancement.terminer": "Complete the launch",
  "v3.ta.lancement.titre": "Project launch",
  "v3.ta.lancement.v1_annoncee": "Technology version 1 will be created when the launch completes.",
  "v3.ta.lancement.voir_technologies": "See the technologies",
  "v3.ta.nouveau.ajouter_composant": "Add the component",
  "v3.ta.nouveau.ajouter_liaison": "Add the link",
  "v3.ta.nouveau.apres": "Target composition",
  "v3.ta.nouveau.aucune_valeur": "No qualified, allowed technology",
  "v3.ta.nouveau.avant": "Current composition",
  "v3.ta.nouveau.categorie": "Category",
  "v3.ta.nouveau.cree": "Draft created.",
  "v3.ta.nouveau.creer": "Create the draft",
  "v3.ta.nouveau.de": "From",
  "v3.ta.nouveau.echec": "The draft was not created.",
  "v3.ta.nouveau.motif_requis": "The reason is required.",
  "v3.ta.nouveau.nature": "Kind of change",
  "v3.ta.nouveau.nature_composition": "Application composition",
  "v3.ta.nouveau.nature_valeur": "Value of a category",
  "v3.ta.nouveau.retirer_liaison": "Remove",
  "v3.ta.nouveau.retirer_liaison_nom": "Remove link {{de}} → {{vers}}",
  "v3.ta.nouveau.titre": "New technology change",
  "v3.ta.nouveau.valeur": "Target value",
  "v3.ta.nouveau.valeur_aide": "Only qualified, allowed technologies are offered; otherwise, request a waiver.",
  "v3.ta.nouveau.vers": "To",
  "v3.ta.preparation.AI_CONSENT_MISSING": "Your consent is missing for this agent’s purpose.",
  "v3.ta.preparation.AI_PURPOSE_MISSING": "No approved purpose for this agent.",
  "v3.ta.preparation.AI_PURPOSE_PENDING": "This agent’s purpose awaits the organisation’s decision.",
  "v3.ta.preparation.ok": "The agent can run.",
  "v3.ta.reprise.done": "done",
  "v3.ta.reprise.todo": "to do",
  "v3.ta.reprise.verified": "verified",
  "v3.ta.risque.high": "high",
  "v3.ta.risque.low": "low",
  "v3.ta.risque.medium": "medium",
  "v3.ta.role.donnees": "Data",
  "v3.ta.role.interface": "Interface",
  "v3.ta.role.service": "Service",
  "v3.ta.role.service_de_plateforme": "Platform service",
  "v3.ta.sans_projet": "Choose a project to open this screen.",
  "v3.ta.statut.analysis": "Analysed",
  "v3.ta.statut.cancelled": "Cancelled",
  "v3.ta.statut.closed": "Closed",
  "v3.ta.statut.deviation_kept": "Deviation kept",
  "v3.ta.statut.draft": "Draft",
  "v3.ta.statut.excluded": "Excluded",
  "v3.ta.statut.in_review": "Submitted",
  "v3.ta.statut.pending": "Pending",
  "v3.ta.statut.propagated": "Propagated",
  "v3.ta.statut.propagating": "Propagating",
  "v3.ta.statut.refused": "Refused",
  "v3.ta.statut.rework": "In rework",
  "v3.ta.statut.to_examine": "To confirm (propagated)",
  "v3.ta.statut.to_reconcile": "To reconcile",
  "v3.ta.statut.to_validate": "To validate",
  "v3.ta.statut.verified": "Verified",
  "v3.ta.technologies.ajouter_composant": "Add a component",
  "v3.ta.technologies.comparer_programme": "Compare with the programme",
  "v3.ta.technologies.composant": "{{role}}: {{element}}",
  "v3.ta.technologies.composants": "Selected components",
  "v3.ta.technologies.composants_vide": "No technology selected: complete the launch.",
  "v3.ta.technologies.demander_changement": "Request a change",
  "v3.ta.technologies.lancement": "project launch",
  "v3.ta.technologies.lancement_a_terminer": "The project launch is not complete.",
  "v3.ta.technologies.lancement_termine": "Launch complete: technologies at version {{version}}.",
  "v3.ta.technologies.onglet.categories": "By category",
  "v3.ta.technologies.onglet.composition": "Composition",
  "v3.ta.technologies.onglet.historique": "History",
  "v3.ta.technologies.onglets": "Technology views",
  "v3.ta.technologies.origine.change_request": "request {{ref}}",
  "v3.ta.technologies.origine.launch": "launch",
  "v3.ta.technologies.origine.propagation": "propagation {{ref}}",
  "v3.ta.technologies.origine.reprise_adr0109": "takeover of existing",
  "v3.ta.technologies.pile": "Ready stack: {{pile}}",
  "v3.ta.technologies.source.organisation": "Inherited from the organisation",
  "v3.ta.technologies.source.programme": "Inherited from the programme",
  "v3.ta.technologies.source.projet": "Project’s own choice",
  "v3.ta.technologies.source.reprise": "Taken over from existing",
  "v3.ta.technologies.terminer_lancement": "Complete the launch",
  "v3.ta.technologies.titre": "Project technologies"
}
